<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>sobre a John john</h1>
      <p>
       Fundada em 2003, a John John é uma plataforma de moda que tem como ícone o jeans mais inovador do Brasil e inspiração na música, transmitindo um lifestyle jovem e cheio de atitude para homens e mulheres de todas as idades. Os esportes, a cultura pop e o universo digital compõem a alma da marca em mood urbano, rocker e noturno, com coleções femininas e masculinas, acessórios e linhas especiais com lavagens e acabamentos únicos. A John John também reúne as maiores celebridades em seus lançamentos, eventos e campanhas, e está sempre presente nos eventos mais divertidos e disputados do mundo, promovendo concursos que fomentam novos talentos em diversas áreas.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
    margin-top: 4rem;
}
h1 {
    font-size: 1.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
}
p {
    font-size: 1.2rem;
    color: #000;
    margin-top: 1rem;
     border-bottom: 2px solid theme-color(primary);
     padding-bottom: 2rem;
     margin-bottom: 1.5rem;
}
</style>